import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AliasInvalidReason } from '../shared/ParkingaboModels';
import {
    LoadingSpinnerPresets,
    PresetLoadingSpinner,
} from 'dg-web-shared/common/components/material-ui/PresetLoadingSpinner';
import { useParkingaboAuthedPathGeneration } from '../routes/RouteUtils';
import { useCustomerContext } from './CustomerProvider.tsx';

export function ProductsPurchaseAccessChecker() {
    const { user, vehicles } = useCustomerContext();
    const navigate = useNavigate();
    const generateAuthedParkingaboPath = useParkingaboAuthedPathGeneration();
    const [routeChecked, setRouteChecked] = useState(false);

    useEffect(() => {
        if (user.overduePaymentsAmountRappen) {
            navigate(generateAuthedParkingaboPath('products/payment-overdue'));
        }

        switch (user.aliasInvalidReason) {
            case AliasInvalidReason.ONBOARDING_REQUIRED:
            case AliasInvalidReason.NOT_FOUND:
            case AliasInvalidReason.LAST_DIRECT_FAILED:
            case AliasInvalidReason.EXPIRED:
                navigate(
                    generateAuthedParkingaboPath('products/payment-missing'),
                );
                break;
        }

        if (vehicles.data.length < 1) {
            navigate(generateAuthedParkingaboPath('products/vehicle-missing'));
        }

        const timeoutId = setTimeout(() => setRouteChecked(true), 0);
        return () => clearTimeout(timeoutId);
    }, [
        generateAuthedParkingaboPath,
        navigate,
        user.aliasInvalidReason,
        user.overduePaymentsAmountRappen,
        vehicles.data.length,
    ]);

    if (!routeChecked) {
        return (
            <PresetLoadingSpinner
                preset={LoadingSpinnerPresets.FillAllSpaceAndCenter}
            />
        );
    } else {
        return <Outlet />;
    }
}
